<template>
    <div id="myApp" class="myApp">
        <!-- 头部 -->
        <div class="myApp-header">
            <span class="header-title">用户：</span>
            <span class="header-user" style="margin-right: 3%;">{{ owner }}</span>
            <button class="header-btn" @click="updateApp">修改应用</button>
            <button class="header-btn manual-btn" @click="createApp">手动初始化应用</button>
            <!-- <button v-if="!firstAppStatus" class="header-btn" style="margin-left: 20px" @click="getToken">获取token</button> -->
        </div>
        <div class="myApp-content">
            <div class="myApp-content-left">
                <div class="left-top">
                    <div class="content-container">
                        <div class="img-wrapper">
                            <img class="imgone" :src="`${$baseUrl}dataMock/homePage/appImg.png`" />
                        </div>
                        <div class="content-name">
                            <span class="content-left">应用名称：</span>
                            <span class="content-right" style="color: #0c78e2;">{{ clientName }}</span>
                        </div>

                        <div class="content-name">
                            <span class="content-left">Client ID：</span>
                            <span
                                class="content-right"
                                style="
                                    -moz-user-select: text;
                                    -webkit-user-select: text;
                                    -ms-user-select: text;
                                    -khtml-user-select: text;
                                    user-select: text;
                                "
                                >{{ clientId }}</span
                            >
                        </div>
                    </div>
                </div>
                <div class="left-middle">
                    <div class="title-line">
                        <div class="title">详细信息</div>
                        <div class="dotline"></div>
                    </div>

                    <div class="content-container">
                        <div class="content-name">
                            <span class="content-left">公司名称：</span>
                            <span class="content-right">{{ company }}</span>
                        </div>
                        <div class="content-name">
                            <span class="content-left">创建时间：</span>
                            <span class="content-right">{{ createAt }}</span>
                        </div>
                        <div class="content-name">
                            <span class="content-left">应用描述：</span>
                            <span class="content-right">{{ remark }}</span>
                        </div>
                    </div>
                </div>
                <div class="left-bottom">
                    <div class="title-line">
                        <div class="title">版权信息</div>
                        <div class="dotline"></div>
                    </div>

                    <div class="content-container">
                        <div class="content-name">
                            <span class="content-left">支持格式：</span>
                            <span class="content-right" style="line-height: 20px;">
                                RVT、RFA、RTE、NWD、Pmodel、NWC、DWG、DXF、imodel、DGN、DWF、DWFX、SKP、IFC、OBJ、DAE、3ds、
                                FBX、STEP、STL、IPT、SLDPRT、CATPart、RVM、3dm、PRJ、DRI、IGS、PRJ、JT、RCS、RCP、SAT、WRL、WRZ、
                                GLTF、XGL、ms3d、x3d、DOC、DOCX、XLS、XLSX、CSV、PPT、PPTX、PDF、MPT、VSD、XML、HTM、HTML、
                                TXT、XPS、OXPS、JPG、JPEG、BMP、PNG、GIF、TIFF、BIMS、JWS、OBMX、BDLS、TEST、JSON、ATT、RVM、VUE
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ***********图表部分*************** -->
            <div class="myApp-content-right">
                <div class="right-top">
                    <div class="item">
                        <div class="item-chart">
                            <appRateChart ref="rateChart1" :chartData="rateChart1" />
                        </div>
                        <div class="item-title">空间使用情况</div>
                    </div>
                    <div class="item">
                        <div class="item-chart">
                            <i class="icon iconfont iconzhuanhuanwenjianzongshu" style="color: #86a9cc;"></i>
                            <span class="item-text" style="color: #86a9cc;">{{ totalFileNum }}</span>
                        </div>
                        <div class="item-title">转换文件总数</div>
                    </div>
                    <div class="item">
                        <div class="item-chart">
                            <i class="icon iconfont iconzhuanhuanwenjianshuchenggongshu" style="color: #41ccaf;"></i>
                            <span class="item-text" style="color: #41ccaf;">{{ successFileNum }}</span>
                        </div>
                        <div class="item-title">转换成功总数</div>
                    </div>
                    <div class="item">
                        <div class="item-chart">
                            <appRateChart ref="rateChart2" :chartData="rateChart2" />
                        </div>
                        <div class="item-title">总转换率</div>
                    </div>
                </div>
                <div class="right-bottom">
                    <div class="item-title">
                        <div>实时转换文件趋势图</div>
                        <div class="select-group">
                            <el-select v-model="trendChartFileType" @change="fileTypeChange">
                                <el-option
                                    v-for="item in trendChartFileTypeArr"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                            <el-select v-model="trendChartDateType" @change="dataTypeChange">
                                <el-option
                                    v-for="item in trendChartDateTypeArr"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item-chart">
                        <appTrendChart ref="trendChart" :chartData="trendChart" />
                    </div>
                </div>
            </div>
        </div>
        <theFirstApp ref="theFirstApp"></theFirstApp>
        <theCredentials v-if="this.$store.state.user.status"></theCredentials>
<!--        <theCredentials v-if="true"></theCredentials>-->
    </div>
</template>

<script>
import appRateChart from 'src/pages/devCenter/consoleLab/myapp/app-rate-chart';
import appTrendChart from 'src/pages/devCenter/consoleLab/myapp/app-trend-chart';
import { getUserToken } from 'src/utils/loginUtils';
import { getAppInfo } from 'src/utils/appUtils';
import { getSpaceCapacity, getJobCount, getJobTrend } from 'src/utils/calculateUtils';
import { formatTime } from 'src/utils/commonUtils';
import theFirstApp from '../components/theFirstApp';
import theCredentials from '../components/theCredentials';

export default {
    name: 'myApp',
    components: {
        appRateChart,
        appTrendChart,
        theFirstApp,
        theCredentials,
    },
    data() {
        return {
            rateChart1: {
                id: 'rateChart1',
                textColor: '#47C2FF',
                backgroundColor: 'rgba(134,169,204,1)',
                startColor: 'rgba(197,249,255,1)',
                endColor: 'rgba(75,194,255,1)',
                centergroundColor: 'rgba(244,250,255,1)',
                textContent: 0,
            },
            rateChart2: {
                id: 'rateChart2',
                textColor: 'rgba(164,107,255,1)',
                backgroundColor: 'rgba(138,134,204,1)',
                startColor: 'rgba(234,223,255,1)',
                endColor: 'rgba(229,142,255,1)',
                centergroundColor: 'rgba(253,244,255,1)',
                textContent: 0,
            },
            trendChart: {
                id: 'trendChart',
                xAxisData: ['13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00'],
                data: [],
            },
            trendXAxis: [],
            trendChartTotal: [],
            trendChartSuccess: [],
            trendChartFileType: 1,
            trendChartFileTypeArr: [
                {
                    label: '文件总数',
                    value: 1,
                },
                {
                    label: '成功数',
                    value: 2,
                },
            ],
            trendChartDateType: 1,
            trendChartDateTypeArr: [
                {
                    label: '小时',
                    value: 1,
                },
                {
                    label: '天',
                    value: 2,
                },
                {
                    label: '月',
                    value: 3,
                },
            ],
            firstAppStatus: true,
            // app的信息
            clientName: '',
            clientId: '',
            owner: '',
            createAt: '',
            remark: '',
            company: '',
            // 其他
            totalFileNum: 0,
            successFileNum: 0,
        };
    },
    methods: {
        initPage() {
            // 获取APP应用信息
            const _self = this;
            // 清空数据
            _self.trendChartTotal = [];
            _self.trendChartSuccess = [];
            _self.trendXAxis = [];
            _self.trendChartFileType = 1;
            _self.trendChartDateType = 1;
            // 获取应用空间情况
            getSpaceCapacity().then((accountRes) => {
                // 容量返回值是 -1 代表无限制，个别是 1G 和 5G
                if (accountRes) {
                    if (accountRes.data.capacity === -1) {
                        _self.rateChart1.textContent = `无限制`;
                    } else {
                        _self.rateChart1.textContent = (
                            (accountRes.data.usedCapacity / accountRes.data.capacity) *
                            100
                        ).toFixed(1);
                    }
                }
            });
            // 获取文件转换情况
            getJobTrend(1).then((accountRes) => {
                // 转换文件的趋势图
                // 数据整理
                accountRes.data.forEach((ele) => {
                    if (ele.time < 10) {
                        _self.trendXAxis.push(`0${ele.time}:00`);
                    } else {
                        _self.trendXAxis.push(`${ele.time}:00`);
                    }
                    _self.trendChartTotal.push(ele.totalCount);
                    _self.trendChartSuccess.push(ele.successCount);
                });
                // 数据赋值
                _self.trendChart.xAxisData = _self.trendXAxis;
                _self.trendChart.data = _self.trendChartTotal;
            });
            getJobCount().then((accountRes) => {
                // 转换文件饼图
                _self.totalFileNum = accountRes.data.totalCount;
                _self.successFileNum = accountRes.data.successCount;
                _self.rateChart2.textContent = parseFloat(
                    (accountRes.data.successCount / accountRes.data.totalCount) * 100,
                ).toFixed(1);
            });
            getAppInfo().then((appRes) => {
                // 判断是否是第一次使用app
                if (appRes.items.length !== 0) {
                    _self.clientName = appRes.items[0].clientName;
                    _self.clientId = appRes.items[0].clientId;
                    _self.owner = appRes.items[0].owner;
                    _self.createAt = formatTime(appRes.items[0].createAt);
                    _self.remark = appRes.items[0].remark;
                    _self.company = appRes.items[0].company;
                } else {
                    _self.createApp();
                }
            });
        },
        createApp() {
            // 创建APP应用信息
            this.$refs.theFirstApp.Open('newApp');
        },
        updateApp() {
            // 修改APP应用信息
            this.$refs.theFirstApp.Open('updateApp', {
                clientName: this.clientName,
                remark: this.remark,
                company: this.company,
            });
        },
        fileTypeChange(val) {
            if (val === 1) {
                this.trendChart.data = this.trendChartTotal;
            } else if (val === 2) {
                this.trendChart.data = this.trendChartSuccess;
            }
        },
        dataTypeChange(type) {
            const _self = this;
            getJobTrend(type).then((accountRes) => {
                // 转换文件的趋势图
                _self.trendXAxis = [];
                _self.trendChartTotal = [];
                _self.trendChartSuccess = [];
                // 数据整理
                if (type === 1) {
                    accountRes.data.forEach((ele) => {
                        if (ele.time < 10) {
                            _self.trendXAxis.push(`0${ele.time}:00`);
                        } else {
                            _self.trendXAxis.push(`${ele.time}:00`);
                        }
                        _self.trendChartTotal.push(ele.totalCount);
                        _self.trendChartSuccess.push(ele.successCount);
                    });
                } else if (type === 2) {
                    accountRes.data.forEach((ele) => {
                        _self.trendXAxis.push(`${ele.time}`);
                        _self.trendChartTotal.push(ele.totalCount);
                        _self.trendChartSuccess.push(ele.successCount);
                    });
                } else if (type === 3) {
                    accountRes.data.forEach((ele) => {
                        _self.trendXAxis.push(`${ele.time}月`);
                        _self.trendChartTotal.push(ele.totalCount);
                        _self.trendChartSuccess.push(ele.successCount);
                    });
                }

                // 数据赋值
                _self.trendChart.xAxisData = _self.trendXAxis;
                if (_self.trendChartFileType === 1) {
                    _self.trendChart.data = _self.trendChartTotal;
                } else if (_self.trendChartFileType === 2) {
                    _self.trendChart.data = _self.trendChartSuccess;
                }
            });
        },
    },
    mounted() {
        this.initPage();
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
.myApp
  width 88%
  background-color $background-darkwhite
  .myApp-header
    height 55px
    font-size 14px
    background-color $background-white
    border-left 1px solid $background-grey
    display flex
    align-items center
    .header-title
      margin-left 2%
      color $font-console
    .header-user
      color $font-btnBlue
    .header-btn
      margin-left 2%
      color $font-btnBlue
      background-color transparent
      margin: 0
      padding: 0
      border: 1px solid $font-btnBlue
      outline: none
      border-radius: 17px
      width 90px
      height 35px
    .header-btn.manual-btn
      width 120px
      margin-left 20px
      visibility hidden
  .myApp-content
    width 100%
    height calc(100% - 75px)
    padding-top 20px
    display flex
    justify-content: space-evenly
    .myApp-content-left
      width 25%
      min-width 300px
      height 97%
      min-height 640px
      display flex
      flex-direction column
      justify-content space-evenly
      .title-line
          dom_center()
          .title
            dom_center()
            position absolute
            font-size 14px
            color $font-console
            background-color $background-white
            border: 1px solid $background-lightgrey
            width 85px
            height 30px
            border-radius: 17px
            z-index 2
          .dotline
            height 1px
            width 85%
            background-color $background-lightgrey
            z-index 1
      .img-wrapper
          display flex
          align-items: center;
          justify-content: center;
          padding 20px
          width 100%
          img
            max-width 370px
            max-height 180px
            width:100%
            height:100%
          .imgone
            position relative
      .content-container
        display flex
        flex-direction: column
        justify-content: space-evenly
        height: 90%
        .content-name
          margin-left: 10%
          .content-left
            font-size 14px
            color $font-title
          .content-right
            font-size 14px
            padding-left: 1%
            color $font-console

      .left-top
        width 100%
        height 40%
        background-color $background-white
      .left-middle
        width 100%
        height 30%
        background-color $background-white
      .left-bottom
        width 100%
        height 30%
        background-color $background-white

    .myApp-content-right
      width 65%
      min-width 710px
      height 97%
      min-height 640px
      display flex
      flex-direction: column
      justify-content: space-between
      .right-top
        width 100%
        height 31%
        display flex
        justify-content: space-between
        .item
          width 22.5%
          height 100%
          background-color $background-white
          .item-chart
            height 79%
            dom_center()
            flex-direction column
            i
              font-size 60px
              color black
            span
              margin-top 10%
              font-family: Arial-Black
              font-size: 35px
              font-weight bold
          .item-title
            display flex
            justify-content center
            height 21%
            font-size 16px
            color $font-itemTitle
      .right-bottom
        width 100%
        height 66%
        background-color $background-white
        overflow hidden
        .item-title
          height 13%
          padding-left: 4%
          padding-right: 4%
          font-size 16px
          color $font-itemTitle
          display: flex
          align-items: center
          justify-content: space-between
        .item-chart
          height 87%
          width 100%
      .right-bottom >>> .el-input__inner
        width 130px
        border-radius 25px
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/myapp/myApp.vue